import type { SpendChartMode } from '@/domains/pages/ai-spend/constants';
import { niceStepSize, type YAxisBounds } from '@/domains/pages/shared/chart-axis';

const TOTAL_SPEND_AXIS_HEADROOM = 1.1;
const TOTAL_SPEND_AXIS_EMPTY_BOUNDS: YAxisBounds = { min: 0, max: 10, stepSize: 2 };

export function parseSpendChartMode(value: string | null): SpendChartMode {
  if (value === 'perTask') return 'perTask';
  return 'total';
}

export function computeTotalSpendAxisBounds(values: number[]): YAxisBounds {
  const finite = values.filter((value) => Number.isFinite(value));
  if (finite.length === 0) {
    return TOTAL_SPEND_AXIS_EMPTY_BOUNDS;
  }

  const dataMax = Math.max(...finite);
  if (dataMax <= 0) {
    return TOTAL_SPEND_AXIS_EMPTY_BOUNDS;
  }

  const target = dataMax * TOTAL_SPEND_AXIS_HEADROOM;
  const stepSize = niceStepSize(target / 4);
  const max = Math.ceil(target / stepSize) * stepSize;

  return { min: 0, max, stepSize };
}
